import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { format } from '@/@core/utils/string';
let AccountDataAnalysisApi = class AccountDataAnalysisApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    postAccountDataAnalysisUserUsageSummary(params) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return this.http.post({
            url: this.urls.postAccountDataAnalysisUserUsageSummary,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        });
    }
    getAccountDataAnalysisData(params) {
        return this.http.post({
            url: this.urls.postAccountDataAnalysisReport,
            data: params,
        });
    }
    postAccountDataAnalysisUserUsageDownload(params, report_name) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        // 使用format函数替换URL中的路径参数
        const url = format(this.urls.postAccountDataAnalysisUserUsageDownload, { report_name });
        return this.http.request({
            url: url,
            method: 'post',
            responseType: 'blob',
            rawResponse: true,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        }).catch(async (err) => {
            // Blob 但是返回了JSON错误
            const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json';
            if (isJsonBlob(err.response?.data)) {
                const txt = await (err.response?.data)?.text();
                err.response.data = (typeof txt === 'string') ? JSON.parse(txt) : txt;
            }
            throw err;
        });
    }
    postAccountDataAnalysisUserSummary(params) {
        return this.http.post({
            url: this.urls.postAccountDataAnalysisUserSummary,
            data: params,
        });
    }
};
AccountDataAnalysisApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.AccountDataAnalysisUrls)),
    __metadata("design:paramtypes", [Object, Object])
], AccountDataAnalysisApi);
export { AccountDataAnalysisApi };
